import React, {useContext, useEffect, useState} from 'react';
import './ProfitReport.scss';
import Loader from "../../../Loader";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import DynaButton from "../../DynaView/DynaButton";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import TableProfitReport from "./TableProfitReport";
import ShowPriceProfitReport from "./ShowPriceProfitReport";
import {SetPrintDataContext} from "../../../../Pages";
import {useNavigate} from "react-router-dom";

const ProfitReport = () => {

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const [initialData, setInitialData] = useState({})
  const [dateFilter, setDateFilter] = useState({
    type: "1",
    startDate: "",
    endDate: "",
    year: "",
    month: "",
  })
  const [yearAndMonth, setYearAndMonth] = useState({
    years: [],
    months: []
  })
  const filterType = [
    {value: "1", label: "نمایش همه"},
    {value: "2", label: "بر اساس سال و ماه"},
    {value: "4", label: "بر اساس بازه زمانی"},
  ]

  useEffect(() => {
    if (dateFilter?.year !== "") {
      yearAndMonth?.data.forEach((v) => {
        if (+v?.year === +dateFilter?.year) {
          setYearAndMonth({...yearAndMonth, months: v?.month})
          setDateFilter({...dateFilter, month: ""})
        }
      })
    }
  }, [dateFilter?.year]);

  const getInitialData = async () => {
    setIsLoad(false)
    const response = await _axios.get(prefixUrl() + "/accountingBalanceSheet/?request=costAndProfit&dateFilter=" + JSON.stringify(dateFilter))
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  const filterHandel = () => {
    void getInitialData()
  }

  const getYearAndMonth = async () => {
    const response = await _axios.get(prefixUrl() + "/accountingTreeChart/?request=submittedYearAndMonth_2")
    if (response.data.status) {
      setYearAndMonth({years: response?.data?.years, months: [], data: response?.data?.data})
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInitialData()
  }, []);

  useEffect(() => {
    void getYearAndMonth()
  }, []);

  const GoPrintPage = () => {
    const sendData = {
      type: "CostAndBenefitPrint",
      data: {
        dateFilter: dateFilter,
        mainData: initialData,
        mySum: {}
      },
    };
    setprint(sendData);
    navigate("/factorprint");
  }

  try {
    return (
      <section className={"main-profit-report"}>
        <div className={"row-filter"}>
          <DynaSelectBox options={filterType}
                         hasFilter={false}
                         label={"نوع فیلتر"}
                         className={"solid-dyna-input"}
                         value={dateFilter?.type}
                         onChange={(data) => setDateFilter({
                           type: data.value,
                           startDate: "",
                           endDate: "",
                           year: "",
                           month: "",
                         })}
          />

          {dateFilter?.type === "4" &&
            <>
              <DynaDatePicker label={"تاریخ شروع"}
                              name={"startDate"}
                              className={"solid-dyna-input"}
                              value={dateFilter?.startDate}
                              setDataFromComponent={(data) => {
                                setDateFilter({...dateFilter, ...data})
                              }}
              />
              <DynaDatePicker label={"تاریخ پایان"}
                              name={"endDate"}
                              className={"solid-dyna-input"}
                              value={dateFilter?.endDate}
                              setDataFromComponent={(data) => {
                                setDateFilter({...dateFilter, ...data})
                              }}
              />
            </>
          }

          {dateFilter?.type === "2" &&
            <>
              <DynaSelectBox options={yearAndMonth?.years}
                             hasFilter={false}
                             label={"سال"}
                             className={"solid-dyna-input"}
                             value={dateFilter?.year}
                             onChange={(data) => setDateFilter({...dateFilter, year: data.value})}
              />
              <DynaSelectBox options={yearAndMonth?.months}
                             hasFilter={false}
                             label={"ماه"}
                             className={"solid-dyna-input"}
                             value={dateFilter?.month}
                             onChange={(data) => setDateFilter({...dateFilter, month: data.value})}
              />
            </>
          }

          <DynaButton className={"simple-but-no-bac"}
                      type={"button"}
                      onClick={filterHandel}>اعمال فیلتر</DynaButton>
        </div>
        {isLoad ?
          <section className={"profit-report-tables"}>
            <TableProfitReport column={initialData?.column}
                               data={initialData?.part_1}
                               priceFields={initialData?.priceFields}/>
            <TableProfitReport column={initialData?.column}
                               data={initialData?.part_2}
                               priceFields={initialData?.priceFields}/>
            <TableProfitReport column={initialData?.column}
                               data={initialData?.part_3}
                               priceFields={initialData?.priceFields}/>
            <TableProfitReport column={initialData?.column}
                               data={initialData?.part_4}
                               priceFields={initialData?.priceFields}/>

            <ShowPriceProfitReport data={initialData}/>
            <div className={"inline-row-button"}>
              <DynaButton className={"simple-but-no-bac"}
                          type={"button"}
                          onClick={GoPrintPage}>پرینت</DynaButton>
            </div>

          </section> : <Loader/>}
      </section>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default ProfitReport;